import { render } from "./Hotspot32.vue?vue&type=template&id=24954f36&scoped=true"
import script from "./Hotspot32.vue?vue&type=script&lang=js"
export * from "./Hotspot32.vue?vue&type=script&lang=js"

import "./Hotspot32.vue?vue&type=style&index=0&id=24954f36&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24954f36"]])

export default __exports__